import type { AppData, Area, Asset, AssetDocument, AllocationSchedule, User } from '../types';

const now = new Date();
const iso = (days = 0) => new Date(now.getTime() - days * 86400000).toISOString();

export const demoUser: User = {
  id: 'USR-ADMIN',
  employeeCode: 'ADMIN01',
  name: 'Admin Head Office',
  role: 'ADMIN',
  active: true,
};

export const areas: Area[] = [
  { id: 'AREA-KHO', code: 'KHO-HO', name: 'Kho Head Office', type: 'WAREHOUSE', manager: 'Admin HO', active: true },
  { id: 'AREA-CHO', code: 'CHO-KIEM', name: 'Khu chờ kiểm tra', type: 'HOLDING', manager: 'Admin HO', active: true },
  { id: 'AREA-LETAN', code: 'LT', name: 'Lễ Tân', type: 'OFFICE', active: true },
  { id: 'AREA-BEP', code: 'BEP', name: 'Bếp', type: 'OFFICE', active: true },
  { id: 'AREA-HOP', code: 'PH', name: 'Phòng Họp', type: 'OFFICE', active: true },
  { id: 'AREA-GD', code: 'PGD', name: 'Phòng Giám Đốc', type: 'OFFICE', active: true },
  { id: 'AREA-KTHO', code: 'KTHO', name: 'Phòng Kế Toán HO', type: 'OFFICE', active: true },
  { id: 'AREA-KTKV', code: 'KTKV', name: 'Phòng Kế Toán Khu Vực', type: 'OFFICE', active: true },
  { id: 'AREA-KD', code: 'KD', name: 'Phòng Kinh Doanh', type: 'OFFICE', active: true },
  { id: 'AREA-LIVE', code: 'LIVE', name: 'Phòng Livestream', type: 'OFFICE', active: true },
];

export const assets: Asset[] = [
  {
    id: 'AST-001', code: 'HO-IT-2026-0001', name: 'Laptop Dell Latitude', category: 'Thiết bị CNTT', trackingMode: 'INDIVIDUAL',
    quantity: 1, unit: 'Cái', status: 'IN_USE', condition: 'GOOD', currentAreaId: 'AREA-KTHO', custodian: 'Nguyễn Thị Minh',
    custodianCode: 'NV021', serial: 'DLT-26-8831', source: 'Chi nhánh Cần Thơ', receivedAt: iso(45), originalValue: 18500000,
    allocationMonths: 36, allocatedAmount: 1541666, createdAt: iso(45),
  },
  {
    id: 'AST-002', code: 'HO-FUR-2026-0002', name: 'Bàn họp 10 chỗ', category: 'Nội thất', trackingMode: 'INDIVIDUAL',
    quantity: 1, unit: 'Bộ', status: 'IN_USE', condition: 'GOOD', currentAreaId: 'AREA-HOP', source: 'Mua mới HO', receivedAt: iso(38),
    originalValue: 12000000, allocationMonths: 24, allocatedAmount: 1000000, createdAt: iso(38),
  },
  {
    id: 'AST-003', code: 'HO-CCDC-2026-0003', name: 'Ghế xoay văn phòng', category: 'Nội thất', trackingMode: 'BULK',
    quantity: 8, unit: 'Cái', status: 'IN_STOCK', condition: 'GOOD', currentAreaId: 'AREA-KHO', source: 'Chi nhánh Long An', receivedAt: iso(12),
    originalValue: 9600000, allocationMonths: 24, allocatedAmount: 400000, createdAt: iso(12),
  },
  {
    id: 'AST-004', code: 'HO-LIVE-2026-0004', name: 'Đèn livestream LED', category: 'Thiết bị Livestream', trackingMode: 'INDIVIDUAL',
    quantity: 1, unit: 'Bộ', status: 'IN_USE', condition: 'GOOD', currentAreaId: 'AREA-LIVE', custodian: 'Trần Gia Hân', custodianCode: 'NV037',
    serial: 'LED-LS-904', source: 'Chi nhánh Đồng Tháp', receivedAt: iso(20), originalValue: 4500000, allocationMonths: 12,
    allocatedAmount: 750000, createdAt: iso(20),
  },
  {
    id: 'AST-005', code: 'HO-ELE-2026-0005', name: 'Lò vi sóng', category: 'Thiết bị bếp', trackingMode: 'INDIVIDUAL',
    quantity: 1, unit: 'Cái', status: 'PENDING_CHECK', condition: 'FAIR', currentAreaId: 'AREA-CHO', source: 'Chi nhánh Vĩnh Long', receivedAt: iso(2),
    originalValue: 2200000, allocationMonths: 12, allocatedAmount: 0, createdAt: iso(2), note: 'Chờ kiểm tra chức năng hâm nóng',
  },
  {
    id: 'AST-006', code: 'HO-OFF-2026-0006', name: 'Máy in Canon 2900', category: 'Thiết bị văn phòng', trackingMode: 'INDIVIDUAL',
    quantity: 1, unit: 'Cái', status: 'REPAIR', condition: 'DAMAGED', currentAreaId: 'AREA-KHO', source: 'Chi nhánh Sóc Trăng', receivedAt: iso(30),
    originalValue: 3800000, allocationMonths: 24, allocatedAmount: 950000, createdAt: iso(30), note: 'Kẹt giấy, chờ báo giá sửa chữa',
  },
];

export const documents: AssetDocument[] = [
  {
    id: 'DOC-001', no: 'TN-202607-0003', type: 'RECEIPT', status: 'COMPLETED', date: iso(2).slice(0, 10), source: 'Chi nhánh Vĩnh Long',
    destinationAreaId: 'AREA-CHO', receiver: 'Admin HO', createdBy: 'Admin HO', createdAt: iso(2),
    lines: [{ id: 'L-001', itemName: 'Lò vi sóng', category: 'Thiết bị bếp', trackingMode: 'INDIVIDUAL', quantity: 1, unit: 'Cái', condition: 'FAIR', originalValue: 2200000, allocationMonths: 12 }],
    checklist: [
      { id: 'C-1', label: 'Đã đối chiếu số lượng', checked: true, required: true },
      { id: 'C-2', label: 'Đã chụp ảnh tình trạng', checked: true, required: true },
      { id: 'C-3', label: 'Đã ghi nhận nguồn bàn giao', checked: true, required: true },
    ],
  },
  {
    id: 'DOC-002', no: 'CP-202607-0002', type: 'ISSUE', status: 'COMPLETED', date: iso(6).slice(0, 10), destinationAreaId: 'AREA-LIVE',
    receiver: 'Trần Gia Hân', receiverCode: 'NV037', createdBy: 'Admin HO', createdAt: iso(6),
    lines: [{ id: 'L-002', assetId: 'AST-004', itemName: 'Đèn livestream LED', category: 'Thiết bị Livestream', trackingMode: 'INDIVIDUAL', quantity: 1, unit: 'Bộ', condition: 'GOOD', originalValue: 4500000, allocationMonths: 12 }],
    checklist: [
      { id: 'C-4', label: 'Đúng tài sản và phụ kiện', checked: true, required: true },
      { id: 'C-5', label: 'Người nhận đã xác nhận', checked: true, required: true },
    ],
  },
  {
    id: 'DOC-003', no: 'TN-202607-0002', type: 'RECEIPT', status: 'DISCREPANCY', date: iso(8).slice(0, 10), source: 'Chi nhánh Đồng Nai',
    destinationAreaId: 'AREA-KHO', receiver: 'Admin HO', createdBy: 'Admin HO', createdAt: iso(8), note: 'Thiếu 1 ghế so với danh sách gửi',
    lines: [{ id: 'L-003', itemName: 'Ghế nhựa', category: 'Nội thất', trackingMode: 'BULK', quantity: 12, actualQuantity: 11, unit: 'Cái', condition: 'GOOD', originalValue: 2200000, allocationMonths: 12 }],
    checklist: [
      { id: 'C-6', label: 'Đã đối chiếu số lượng', checked: true, required: true },
      { id: 'C-7', label: 'Đã lập ghi chú chênh lệch', checked: true, required: true },
    ],
  },
];

export const allocations: AllocationSchedule[] = assets
  .filter((asset) => asset.originalValue > 0 && asset.allocationMonths > 0)
  .map((asset, index) => ({
    id: `AL-${index + 1}`,
    assetId: asset.id,
    assetCode: asset.code,
    assetName: asset.name,
    areaId: asset.currentAreaId,
    startMonth: '2026-06',
    months: asset.allocationMonths,
    totalValue: asset.originalValue,
    monthlyAmount: Math.round(asset.originalValue / asset.allocationMonths),
    allocatedPeriods: Math.round(asset.allocatedAmount / Math.max(1, Math.round(asset.originalValue / asset.allocationMonths))),
    allocatedAmount: asset.allocatedAmount,
    remainingAmount: Math.max(0, asset.originalValue - asset.allocatedAmount),
    status: asset.allocatedAmount >= asset.originalValue ? 'COMPLETED' : 'ACTIVE',
  }));

export const initialData = (): AppData => ({
  currentUser: demoUser,
  areas,
  assets,
  documents,
  allocations,
  activities: [
    { id: 'ACT-1', type: 'RECEIPT', title: 'Tiếp nhận TN-202607-0003', detail: 'Lò vi sóng từ Chi nhánh Vĩnh Long', at: iso(2), by: 'Admin HO' },
    { id: 'ACT-2', type: 'ISSUE', title: 'Cấp phát CP-202607-0002', detail: 'Đèn livestream LED → Phòng Livestream', at: iso(6), by: 'Admin HO' },
    { id: 'ACT-3', type: 'RECEIPT', title: 'Ghi nhận chênh lệch', detail: 'TN-202607-0002 thiếu 1 ghế nhựa', at: iso(8), by: 'Admin HO' },
    { id: 'ACT-4', type: 'ALLOCATION', title: 'Đã tính phân bổ tháng 06/2026', detail: '5 lịch phân bổ được cập nhật', at: iso(12), by: 'Kế toán HO' },
  ],
});
